import styled from '@emotion/styled';
import { Box, Theme } from '@prometheus/components';

export const IconWrapper: any = styled(Box, {
  shouldForwardProp: prop => prop !== 'severity',
})`
  border-radius: 2px;
  display: flex;
  justify-content: space-around;
  padding: 0;
  align-items: center;
  width: 26px;
  height: 26px;
  svg {
    font-size: 26px;
    margin-top: -1px;
  }

  :hover {
    background-color: ${({
      theme,
      severity,
    }: {
      theme: Theme;
      severity: 'error' | 'info' | 'warning' | 'success';
    }) => (!severity ? 'transparent' : theme.palette[severity].main + 20)};
  }
`;
